var Vector2Utils = (function () {
    function Vector2Utils() {
    }
    Vector2Utils.equals = function (a, b) {
        if (a.equals) {
            return a.equals(b);
        }
        return a.x === b.x && a.y === b.y;
    };
    Vector2Utils.create = function (x, y) {
        return { x: x, y: y };
    };
    Vector2Utils.clone = function (vector) {
        return { x: vector.x, y: vector.y };
    };
    Vector2Utils.add = function (a, b) {
        return { x: a.x + b.x, y: a.y + b.y };
    };
    Vector2Utils.manhattanDistance = function (a, b) {
        return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
    };
    Vector2Utils.distance = function (a, b) {
        var dx = a.x - b.x;
        var dy = a.y - b.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Vector2Utils.toHash = function (vector) {
        var x = (vector.x + this.MAX_COORD) | 0;
        var y = (vector.y + this.MAX_COORD) | 0;
        return (x << 16) | y;
    };
    Vector2Utils.toKey = function (vector) {
        return "".concat(vector.x, ",").concat(vector.y);
    };
    Vector2Utils.fromHash = function (hash) {
        var x = (hash >> 16) - this.MAX_COORD;
        var y = (hash & 0xFFFF) - this.MAX_COORD;
        return { x: x, y: y };
    };
    Vector2Utils.HASH_MULTIPLIER = 73856093;
    Vector2Utils.MAX_COORD = 32767;
    return Vector2Utils;
}());
export { Vector2Utils };
